var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "head_title" } },
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { cols: "12", id: "main_content_minwidthset" },
        },
        [
          _vm.playerFromWhere.from === "dashboard"
            ? _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0 pl-3 pr-3",
                  attrs: { align: "center", id: "header_height" },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0 pa-0",
                                  staticStyle: {
                                    color: "#08B0FF",
                                    "font-size": "1rem",
                                  },
                                  attrs: {
                                    id: "back_clean_btn",
                                    width: "auto",
                                    height: "50px",
                                    elevation: "0",
                                  },
                                  on: { click: _vm.backPage },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.tn(_vm.prevRoute.name)) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.routeName === "videoDownloadSetting"
                            ? [
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: {
                                    "max-height": "50px",
                                    "max-width": "1.5rem",
                                    src: require("@/assets/images/history_arrow.png"),
                                  },
                                }),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    staticStyle: {
                                      color: "#08B0FF",
                                      "font-size": "1rem",
                                    },
                                    attrs: {
                                      id: "back_clean_btn",
                                      width: "auto",
                                      height: "50px",
                                      elevation: "0",
                                    },
                                    on: { click: _vm.routerBack },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(this.streamData.cameraName) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: {
                                    "max-height": "50px",
                                    "max-width": "1.5rem",
                                    src: require("@/assets/images/history_arrow.png"),
                                  },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s("録画データダウンロード") +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: {
                                    "max-height": "50px",
                                    "max-width": "1.5rem",
                                    src: require("@/assets/images/history_arrow.png"),
                                  },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(this.streamData.cameraName) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.playerFromWhere.from === "search"
            ? _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0 pl-3 pr-3",
                  attrs: { align: "center", id: "header_height" },
                },
                [
                  _c(
                    "router-link",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: { to: { path: "/store-search" } },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                            "text-align": "center",
                          },
                          attrs: { cols: "auto", align: "center" },
                        },
                        [_vm._v(" " + _vm._s(_vm.t("top")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-3",
                    attrs: {
                      "max-height": "100%",
                      "max-width": "1.5rem",
                      src: require("@/assets/images/history_arrow.png"),
                    },
                  }),
                  _c(
                    "router-link",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: { to: { path: "/store-search/detail" } },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                            "text-align": "center",
                          },
                          attrs: { cols: "auto", align: "center" },
                        },
                        [_vm._v(" " + _vm._s(_vm.tsc("searchResult")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _vm.routeName === "videoDownloadSetting"
                    ? [
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "100%",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-0 pa-0",
                            staticStyle: {
                              color: "#08B0FF",
                              "font-size": "1rem",
                            },
                            attrs: {
                              id: "back_clean_btn",
                              width: "auto",
                              height: "50px",
                              elevation: "0",
                            },
                            on: { click: _vm.backToStoreSearchCCTV },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$route.query.customerName) + " "
                            ),
                          ]
                        ),
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "100%",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "router-link",
                          {
                            staticStyle: { color: "transparent" },
                            attrs: {
                              to: { path: _vm.$routerHistory.previous().path },
                            },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                staticStyle: {
                                  color: "#08B0FF",
                                  "font-size": "1rem",
                                  "text-align": "center",
                                },
                                attrs: { cols: "auto", align: "center" },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(this.streamData.cameraName) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "100%",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                          [_vm._v(" " + _vm._s("録画データダウンロード") + " ")]
                        ),
                      ]
                    : [
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "100%",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "router-link",
                          {
                            staticStyle: { color: "transparent" },
                            attrs: {
                              to: { path: _vm.$routerHistory.previous().path },
                            },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                staticStyle: {
                                  color: "#08B0FF",
                                  "font-size": "1rem",
                                  "text-align": "center",
                                },
                                attrs: { cols: "auto", align: "center" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$route.query.customerName) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "100%",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                          [
                            _vm._v(
                              " " + _vm._s(this.streamData.cameraName) + " "
                            ),
                          ]
                        ),
                      ],
                ],
                2
              )
            : _vm.playerFromWhere.from === "privateSplitScreen"
            ? _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0 pl-3 pr-3",
                  attrs: { align: "center", id: "header_height" },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0 pa-0",
                                  staticStyle: {
                                    color: "#08B0FF",
                                    "font-size": "1rem",
                                  },
                                  attrs: {
                                    id: "back_clean_btn",
                                    width: "auto",
                                    height: "50px",
                                    elevation: "0",
                                  },
                                  on: { click: _vm.backPage },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.tn(_vm.prevRoute.name)) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.routeName === "videoDownloadSetting"
                            ? [
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: {
                                    "max-height": "50px",
                                    "max-width": "1.5rem",
                                    src: require("@/assets/images/history_arrow.png"),
                                  },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        staticStyle: {
                                          color: "#08B0FF",
                                          "font-size": "1rem",
                                        },
                                        attrs: {
                                          id: "back_clean_btn",
                                          width: "auto",
                                          height: "50px",
                                          elevation: "0",
                                        },
                                        on: { click: _vm.backPage },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.splitScreenNameFormat(
                                                _vm.playerFromWhere.name
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: {
                                    "max-height": "50px",
                                    "max-width": "1.5rem",
                                    src: require("@/assets/images/history_arrow.png"),
                                  },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        staticStyle: {
                                          color: "#08B0FF",
                                          "font-size": "1rem",
                                        },
                                        attrs: {
                                          id: "back_clean_btn",
                                          width: "auto",
                                          height: "50px",
                                          elevation: "0",
                                        },
                                        on: { click: _vm.routerBack },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(this.streamData.cameraName) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: {
                                    "max-height": "50px",
                                    "max-width": "1.5rem",
                                    src: require("@/assets/images/history_arrow.png"),
                                  },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s("録画データダウンロード") +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: {
                                    "max-height": "50px",
                                    "max-width": "1.5rem",
                                    src: require("@/assets/images/history_arrow.png"),
                                  },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        staticStyle: {
                                          color: "#08B0FF",
                                          "font-size": "1rem",
                                        },
                                        attrs: {
                                          id: "back_clean_btn",
                                          width: "auto",
                                          height: "50px",
                                          elevation: "0",
                                        },
                                        on: { click: _vm.routerBack },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.splitScreenNameFormat(
                                                _vm.playerFromWhere.name
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mr-3",
                                  attrs: {
                                    "max-height": "50px",
                                    "max-width": "1.5rem",
                                    src: require("@/assets/images/history_arrow.png"),
                                  },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(this.streamData.cameraName) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0 pl-3 pr-3",
                  attrs: { align: "center", id: "header_height" },
                },
                [
                  _c(
                    "router-link",
                    {
                      staticStyle: { color: "transparent" },
                      attrs: {
                        to: {
                          path: "/store-group/detail?groupId=" + _vm.groupId,
                        },
                      },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: {
                            color: "#08B0FF",
                            "font-size": "1rem",
                            "text-align": "center",
                          },
                          attrs: { cols: "auto", align: "center" },
                        },
                        [_vm._v(" " + _vm._s(_vm.groupName) + " ")]
                      ),
                    ],
                    1
                  ),
                  _vm.routeName === "videoDownloadSetting"
                    ? [
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "50px",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0",
                                staticStyle: {
                                  color: "#08B0FF",
                                  "font-size": "1rem",
                                },
                                attrs: {
                                  id: "back_clean_btn",
                                  width: "auto",
                                  height: "50px",
                                  elevation: "0",
                                },
                                on: { click: _vm.backToStoreGroupCCTV },
                              },
                              [
                                _vm.playerFromWhere.from === "group"
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$route.query.customerName
                                          ) +
                                          " "
                                      ),
                                    ]
                                  : _vm.playerFromWhere.from === "cameraList"
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.playerFromWhere.name) +
                                          " "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.playerFromWhere.name) +
                                          " "
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "50px",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "router-link",
                          {
                            staticStyle: { color: "transparent" },
                            attrs: {
                              to: { path: _vm.$routerHistory.previous().path },
                            },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                staticStyle: {
                                  color: "#08B0FF",
                                  "font-size": "1rem",
                                  "text-align": "center",
                                },
                                attrs: { cols: "auto", align: "center" },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(this.streamData.cameraName) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "50px",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                          [_vm._v(" " + _vm._s("録画データダウンロード") + " ")]
                        ),
                      ]
                    : [
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "100%",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "router-link",
                          {
                            staticStyle: { color: "transparent" },
                            attrs: {
                              to: { path: _vm.$routerHistory.previous().path },
                            },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                staticStyle: {
                                  color: "#08B0FF",
                                  "font-size": "1rem",
                                  "text-align": "center",
                                },
                                attrs: { cols: "auto", align: "center" },
                              },
                              [
                                _vm.playerFromWhere.from === "group"
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$route.query.customerName
                                          ) +
                                          " "
                                      ),
                                    ]
                                  : _vm.playerFromWhere.from === "cameraList"
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.playerFromWhere.name) +
                                          " "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.playerFromWhere.name) +
                                          " "
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c("v-img", {
                          staticClass: "ma-0 pa-0 mr-3",
                          attrs: {
                            "max-height": "100%",
                            "max-width": "1.5rem",
                            src: require("@/assets/images/history_arrow.png"),
                          },
                        }),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                          [
                            _vm._v(
                              " " + _vm._s(this.streamData.cameraName) + " "
                            ),
                          ]
                        ),
                      ],
                ],
                2
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }